import { TicketSelectorOption, TicketType } from '@nx-ng/types';
import { translationMap } from './ticket-selector.config';

export const reorder = (
  first: TicketType,
  order: TicketType[]
): TicketType[] => {
  const newOrder = order.filter((i) => i !== first);
  if (order.includes(first)) {
    // Only put something back if it's in the original
    newOrder.unshift(first);
  }
  return newOrder;
};

export const hydrate = (order: TicketType[]): TicketSelectorOption[] => {
  const hydrated = order.map((i) => translationMap[i]);
  return hydrated;
};
